import { getGAMeasurmentId } from "./environmentUtils";

//init Google Analyticis
export const initGA = () => {
  const measurementId = getGAMeasurmentId();
  if (!window || !document || !measurementId) return;

  const gtagUrl = "https://www.googletagmanager.com/gtag/js";
  const script = document.createElement("script");
  script.async = true;
  script.src = `${gtagUrl}?id=${measurementId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(...props) {
    window.dataLayer.push(props);
  }

  gtag("js", new Date());
  gtag("config", measurementId);
};
